'use strict';

import React from "react";
import PropTypes from 'prop-types';

import {FaGraduationCap, FaQuestionCircle} from "react-icons/fa";

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import HelpPopover from "@uw-it-sis/lib-react/lib/HelpPopover";
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";

const IntendedGraduation = ({termId, className = "text-purple", showText = false}) => {
    const degreeEarnedQuarter = appStore.getUserAttribute('degreeEarnedQuarter');
    const degreeEarnedYear = appStore.getUserAttribute('degreeEarnedYear');

    // If both user attributes for quarter/year have data
    if (degreeEarnedQuarter && degreeEarnedYear) {
        // Create a termId from the quarter name for comparison
        const degreeEarnedTermId = TermUtils.makeTermIdFromTermName(`${degreeEarnedQuarter} ${degreeEarnedYear}`);
        // If the termId of the degree earned data matches the termId supplied via props for term being displayed
        if (degreeEarnedTermId === termId) {
            let ayvPlacement;
            // For AYV, keep popover within page and not overflow either left or right boundaries
            switch (degreeEarnedQuarter.toLowerCase()) {
                case 'autumn':
                    ayvPlacement = 'right';
                    break;
                case 'summer':
                    ayvPlacement = 'left';
                    break;
                default:
                    ayvPlacement = 'bottom';
            }
            // Create object for attributes to past to HelpPopover component
            let helpPopoverAttr = {
                placement: showText ? "right" : ayvPlacement
            };

            if (showText) {
                // Create UI of icon, text, and help icon as trigger for popover
                helpPopoverAttr.link =
                    <div className="d-inline-flex align-items-center">
                        <FaGraduationCap className={className + " fs-5"} aria-hidden={true} />
                        <span className="mx-2">Intended graduation quarter</span>
                        <FaQuestionCircle className="text-muted" aria-hidden={true} />
                    </div>
                helpPopoverAttr.className = "mt-3";
            } else {
                // Set HelpPopover to use just icon for trigger
                helpPopoverAttr.icon = FaGraduationCap;
                helpPopoverAttr.size = "1.5rem";
                helpPopoverAttr.className = className;
            }

            return (
                <HelpPopover
                    title="Intended Graduation Quarter"
                    {...helpPopoverAttr}>
                    This is your intended graduation quarter as indicated from your application for graduation.
                    If you believe there is an issue, please reach out to your department advisor.
                </HelpPopover>
            );
        }
    }
    // Either degree earned data is not sufficient or quarter/year does not match termId for display
    return null;
}

IntendedGraduation.propTypes = {
    className: PropTypes.string, // CSS classes to apply to the icon of the component (mostly for icon color)
    showText: PropTypes.bool, // Whether to show icon and text version or just icon
    termId: PropTypes.string.isRequired // The termId of term being displayed
}

export default IntendedGraduation;